import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Landing } from './pages/Landing';
import type { AdVersion } from './pages/Landing';
import { ThankYou } from './pages/ThankYou';
import { track } from './utils/tracking';
import { initMetaPixel } from './utils/metaPixel';
import { initClarity } from './utils/clarity';
interface AppProps {
  /** Meta ad angle: A = independence, B = AI and follow-up, C = marketing, D = systems and support. */
  adVersion?: AdVersion;
  showStickyMobileCta?: boolean;
}
export function App({
  adVersion = 'A',
  showStickyMobileCta = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
    initClarity();
    track('landing_page_view', {
      ad_version: adVersion
    });
  }, [adVersion]);
  return <BrowserRouter data-id="element-0" data-mp="2wi5nljineppu">
      <Routes data-id="element-1" data-mp="28u5zysgmvffh">
        <Route path="/" element={<Landing adVersion={adVersion} showStickyMobileCta={showStickyMobileCta} data-id="element-3" data-mp="28sl5t3y8dyi5" />} data-id="element-2" data-mp="28tmfp53igeya" />
        <Route path="/thank-you" element={<ThankYou data-id="element-5" data-mp="3ijxoypkvdyjd" />} data-id="element-4" data-mp="23v2rsz5cwt3a" />
        <Route path="*" element={<Landing adVersion={adVersion} showStickyMobileCta={showStickyMobileCta} data-id="element-7" data-mp="3ijpdn24eb1aa" />} data-id="element-6" data-mp="3ikr0s4yore8d" />
      </Routes>
    </BrowserRouter>;
}